import React, { FC } from 'react';
import { Configuration, RedirectRequest } from '@azure/msal-browser';
import { useActions, adLogout,resetStore, initializeCiamUser, initializeCiamLogin } from '@trip-ux/redux-store';
import { AdAuthContext } from './contexts';
import { getStorage } from '../util';

export interface AdAuthProps {
  config: Configuration;
  loginRequest: RedirectRequest;
  children?: React.ReactNode;
}

export const AdAuthProvider: FC<AdAuthProps> = ({ children, config, loginRequest }) => {
  const storage = getStorage('sessionStorage');
  const actions = useActions({
    adLogout,
    resetStore,
    initializeCiamLogin
  });

  const logout = () => actions.adLogout(storage).then(actions.resetStore());
  const handleCiamLogin = () => actions.initializeCiamLogin();

  return <AdAuthContext.Provider value={{ logout, handleCiamLogin }}>{children}</AdAuthContext.Provider>;
};

AdAuthContext.displayName = 'AdAuthContext';
export default AdAuthContext;
